import React from 'react';
import PropTypes from 'prop-types';

import { EditableText } from 'components';
import { StyledDescription } from './style';

const EditableDescription = ({
  name,
  pageId,
  description,
  updateDescription,
  createVariables,
}) => (
  <StyledDescription>
    <EditableText
      createVariables={createVariables}
      initialText={description}
      multiline
      name={name}
      pageId={pageId}
      placeholder="Add Description"
      saveChanges={updateDescription}
    />
  </StyledDescription>
);

EditableDescription.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  pageId: PropTypes.string.isRequired,
  createVariables: PropTypes.func.isRequired,
  updateDescription: PropTypes.func.isRequired,
};

export default React.memo(EditableDescription);
